// kyc update

import React from 'react';
import { View, TouchableOpacity, Dimensions, ScrollView, FlatList, ImageBackground } from 'react-native';
import { get, isEmpty } from 'lodash';
import CText from '../../common/CText';
import CView from '../../common/CView';
import CHeader from '../../common/CHeader';
import CImage from '../../common/CImage';
import QuickLinks from '../Profile/QuickLinks';
import * as RootNavigation from '../../utilities/RootNavigation';
import useStyles from './SelectVehicleForCloseTag_Styles';
import TollgateBg from '../../assets/images/serviceReq/tollgate_bg.png';
import { COLORS } from '../../constant';

const isSmallDevice = Dimensions.get('window').width < 767;
const isTabView = Dimensions.get('window').width > 767 && Dimensions.get('window').width < 1024;

export default function SelectVehicleForNPCICloseTag(props) {
  const vehicleList = props?.vehicleList || []
  const styles = useStyles();
  const tagClosedByNpci = vehicleList.filter(item=>{return item.status == "Closed by NPCI"})
  const tagsMarkedForClosure = vehicleList.filter(item=>{return item.status == "NPCI LB"})

  return (
    <>
      <View style={[styles.container, { marginTop: 0 }]}>
        <View style={styles.navWidget}>
          <View style={{ width: '100%' }}>
            <CHeader
              title='Tag Review'
              onPress={() => {
                RootNavigation.navigate('ServiceRequest');
              }}
            />
          </View>
        </View>
        <View style={styles.listContentWrapper}>
          <ImageBackground
            source={TollgateBg}
            resizeMode='cover'
            style={styles.listContentL}>
            <View style={styles.listContentLBg}>
              <CText.npciMarkedTitle>{'One vehicle, \nOne FASTag policy'}</CText.npciMarkedTitle>
              <CText.npciMarkedDesc>
                {
                  'As per the government’s One Vehicle, One FASTag Policy, One or more of your FASTags have been marked for closure/ forced closed by NPCI since multiple bank tags were linked to your vehicle(s). Please close your tag within the next 7 days/claim any positive balance on the tag (if any)'
                }
              </CText.npciMarkedDesc>
              <CImage.IconHand></CImage.IconHand>
            </View>
          </ImageBackground>
          <View style={styles.listContentR}>
            {tagsMarkedForClosure?.length > 0 && 
            <ScrollView
              showsHorizontalScrollIndicator={false}
              vertical={true}
              style={[styles.scrollViewStyle, { width: '100%' }]}>
              <View style={styles.listContentRTitleBar}>
                <CText.npciMarkedVehListTitle>{`Tags marked for closure (${tagsMarkedForClosure.length})`}</CText.npciMarkedVehListTitle>
                <CText.npciMarkedVehListDesc>{'Click on “Proceed to Tag Closure” \nto close the duplicate tag'}</CText.npciMarkedVehListDesc>
              </View>
              <FlatList
                extraData
                style={styles.flatListStyleNPCI}
                data={isEmpty(tagsMarkedForClosure) ? [] : tagsMarkedForClosure}
                key={tagsMarkedForClosure.length}
                renderItem={({ item }) => {
                  return (
                    <View
                      style={styles.cardStyle}>
                      <View style={{ flexDirection: 'row' }}>
                        <CImage.CarImgGray></CImage.CarImgGray>
                        <CView style={{ marginRight: 10, marginLeft: 10 }}>
                          <View style={[styles.vehicleViewStyle ,{width:120}]}>
                            <CText.vrnText> {get(item,'vrn',"")}</CText.vrnText>
                            <CText.vehicleModal> {get(item, 'vehicleModel', '')} </CText.vehicleModal>
                          </View>
                          
                          <CView
                            FR
                            AC
                            MT={5}>
                            <CImage.IconToll></CImage.IconToll>
                            <CView style={{ marginLeft: 20 }}>
                              <CText.priceText>
                                {'\u20B9  '} {get(item, 'fastagBalance', '').toFixed(2)}{' '}
                              </CText.priceText>
                              <CText.vehicleModal>{'FASTag Balance'}</CText.vehicleModal>
                            </CView>
                            
                          </CView>
                         
                         
                        </CView>
                        <TouchableOpacity style={styles.closureTabStyle}>
                          <CText.markedForCloseText>{'Marked for closure'}</CText.markedForCloseText>
                        </TouchableOpacity>
                      </View>
                      <CView
                        FR
                        AC>
                        <CImage.IconMPGray></CImage.IconMPGray>
                        <View style={{ width: 170, height: 32, marginVertical: 8 }}>
                          <TouchableOpacity onPress={()=>{props.onProceed(item)}} style={{ backgroundColor: COLORS.red, padding: 4, height: 30, borderRadius: 15, alignItems: 'center', justifyContent: 'center' }}>
                            <CText.markedForCloseText style={{ color: '#fff' }}>{'Proceed to Tag Closure'}</CText.markedForCloseText>
                          </TouchableOpacity>
                        </View>
                      </CView>
                    </View>
                  );
                }}
                keyExtractor={(item) => item.id}
                numColumns={isSmallDevice ? null : isTabView ? null : null}
              />
            </ScrollView> }
           {tagClosedByNpci?.length > 0 && 
            <ScrollView
              showsHorizontalScrollIndicator={false}
              vertical={true}
              style={[styles.scrollViewStyle, { width: '100%' }]}>
              <View style={styles.listContentRTitleBar}>
                <CText.npciMarkedVehListTitle>{`Tags closed by NPCI (${tagClosedByNpci.length})` }</CText.npciMarkedVehListTitle>
                <CText.npciMarkedVehListDesc>{'Click on “Proceed to Tag Closure” to close the duplicate tag'}</CText.npciMarkedVehListDesc>
              </View>
              <FlatList
                extraData
                style={styles.flatListStyleNPCI}
                data={isEmpty(tagClosedByNpci) ? [] : tagClosedByNpci}
                key={tagClosedByNpci.length}
                renderItem={({ item }) => {
                  return (
                    <CView
                      style={{
                        justifyContent: 'center',
                        paddingLeft: 10,
                        paddingRight: 10,
                        marginRight: 10,
                        marginBottom: 5,
                        width: 300,
                        minHeight: 120,
                        borderWidth: 1,
                        borderColor: COLORS.boderColor,
                        borderRadius: 10,
                      }}>
                      <View style={{ flexDirection: 'row' }}>
                        <CImage.CarImgGray></CImage.CarImgGray>
                        <CView style={{ marginRight: 10, marginLeft: 10 }}>
                          <View style={[styles.vehicleViewStyle, {width:120}]}>
                            <CText.vrnText> {get(item, 'vrn', '')}</CText.vrnText>
                            <CText.vehicleModal> {get(item, 'vehicleModel', '')} </CText.vehicleModal>
                          </View>
                          <CView
                            FR
                            AC
                            MT={5}>
                            <CImage.IconToll></CImage.IconToll>
                            <CView style={{ marginLeft: 20 }}>
                              <CText.priceText>
                                {'\u20B9  '} {get(item, 'fastagBalance', '').toFixed(2)}{' '}
                              </CText.priceText>
                              <CText.vehicleModal>{'FASTag Balance'}</CText.vehicleModal>
                            </CView>
                          </CView>
                        </CView>
                        <TouchableOpacity style={styles.closureTabStyle}>
                          <CText.markedForCloseText>{'Closed'}</CText.markedForCloseText>
                        </TouchableOpacity>
                      </View>
                      <CView
                        FR
                        AC>
                        <CImage.IconMPGray></CImage.IconMPGray>
                        <View style={{ width: 170, height: 32, marginVertical: 8 }}>
                          <TouchableOpacity  onPress={()=>{props.onProceed(item)}} style={{ backgroundColor: COLORS.red, padding: 4, height: 30, borderRadius: 15, alignItems: 'center', justifyContent: 'center' }}>
                            <CText.markedForCloseText style={{ color: '#fff' }}>{'Proceed to Tag Closure'}</CText.markedForCloseText>
                          </TouchableOpacity>
                        </View>
                      </CView>
                    </CView>
                  );
                }}
                keyExtractor={(item) => item.id}
                numColumns={isSmallDevice ? null : isTabView ? null : null}
              />
            </ScrollView> }
          </View>
        </View>
        <View style={{ marginTop: 30, marginBottom: 30 }}>
          <QuickLinks navigation={props.navigation} />
        </View>
      </View>
    </>
  );
}
